import React, { useCallback, useState, useEffect } from 'react';
import { IInputPassword } from '@smiles/smiles-ui-kit-react';
import { Input } from 'reactstrap';

const mapToCssModules = (
    cssModule: Array<string | undefined> = [],
  ): string => {
    if (!cssModule) {
      return cssModule;
    }
  
    return cssModule
      .filter((className: string | undefined) => !!className)
      .join(' ');
  };

  
export const TangInputPassword: React.FC<IInputPassword> = ({
  idInput = '',
  idPreviewOn = '',
  idPreviewOff = '',
  idErrorMsg = '',
  className = '',
  textLabel = '',
  disabled = false,
  error = false,
  onlyNumbers = false,
  errorMessage = 'Error message',
  innerRef,
  ref,
  flipFlopClear,
  onChange = () => undefined,
  onKeyPress = () => undefined,
  onFocus = () => undefined,
  onBlur = () => undefined,
  onPaste = () => undefined,
  ...params
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isTyping, setIsTyping] = useState<boolean>(false);
  const [isFilled, setIsFilled] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  const enableOutline = useCallback((e) => {
    setIsFocused(true);
    onFocus(e);
  }, []);
  const disableOutline = useCallback((e) => {
    setIsFocused(false);
    onBlur(e);
  }, []);

  const handleDebouncedValue = () => {
    const hasValue = value.length > 0;
    setIsTyping(false);
    setIsFilled(hasValue);
  };

  useEffect(() => {
    const debounceTimeout = setTimeout(handleDebouncedValue, 500);
    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [value]);

  useEffect(() => {
    setValue('');
  }, [flipFlopClear]);

  const handleOnChange = useCallback(
    (event) => {
      let text = event.target.value;

      const hasOnlyNumbers = /^\d+$/g.test(event.target.value);

      if (onlyNumbers && !hasOnlyNumbers) {
        text = text.replace(/\D+/g, '');
      }

      setIsTyping(true);
      setValue(text);
      onChange({
        ...event,
        target: {
          value: text,
        },
      });
    },
    [onlyNumbers],
  );

  return (
    <div
      className={mapToCssModules([
        'input-group icon password',
        isVisible ? 'visible' : '',
        disabled ? 'disabled' : '',
        isTyping ? 'typing' : '',
        isFilled ? 'filled' : '',
        isFocused ? 'input-outline' : '',
        error ? 'error' : '',
      ])}
    >
      {textLabel && <label htmlFor={idInput}>{textLabel}</label>}
      <div>
        <Input
          id={idInput}
          className={className}
          disabled={disabled}
          value={value}
          type={isVisible ? 'text' : 'password'}
          ref={ref}
          onChange={handleOnChange}
          onFocus={enableOutline}
          onBlur={disableOutline}
          onPaste={onPaste}
          onKeyPress={onKeyPress}
          innerRef={innerRef}
          maxLength={4}
          {...params}
        />
        <i
          id={idPreviewOff}
          onClick={() => setIsVisible((prevState) => !prevState)}
          className="material-icons notranslate"
        >
          &#xe8f5;
        </i>
        <i
          id={idPreviewOn}
          onClick={() => setIsVisible((prevState) => !prevState)}
          className="material-icons notranslate"
        >
          &#xe8f4;
        </i>
      </div>
      <div className="input-error">
        {error && (
          <>
            <i className="material-icons notranslate">&#xe001;</i>
            <label id={idErrorMsg} htmlFor="input-text">
              {errorMessage}
            </label>
          </>
        )}
      </div>
    </div>
  );
};
